import LocalStorageManager from './localStorageManager'
import roles from '../data/roles.json'
import localStorageKeys from './localStorageKeys'

class Customer {
    getUserFullNameFirstChars = customer => {
        const result = customer?.name?.charAt(0) + customer?.surname?.charAt(0)
        return result || null
    }

    getUserFullName = customer => {
        return customer ? customer?.name + ' ' + customer?.surname : ''
    }

    isRoot = () => {
        const customerRole = LocalStorageManager.get('customer')?.role
        return customerRole === roles.root.value
    }

    isManager = () => {
        const customerRole = LocalStorageManager.get('customer')?.role
        return customerRole === roles.manager.value
    }

    isMemberRoot = role => {
        return role === roles.root.value
    }

    isCurrentUser = customerId => {
        const localCustomerId = LocalStorageManager.get('customer')?.customer_id
        return customerId === localCustomerId
    }

    getCurrentUserTeamId = () => {
        return localStorage.getItem(localStorageKeys.TEAM_ID)
    }

    getCurrentCustomerId = () => {
        return LocalStorageManager.get('customer')?.customer_id
    }

    getCurrencyByCustomerTimezone = () => {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        return timeZone.includes('Europe/') ? 'eur' : 'usd'
    }

    isOwnTeam = () => {
        return this.isRoot() || LocalStorageManager.get(localStorageKeys.TEAM)?.team_id === localStorage.getItem(localStorageKeys.TEAM_ID)
    }
}

export default new Customer()
